import { webServerHostUrl } from '../../utilities/url_util';
import { productMetaTagString } from '../../utilities/meta_tags_util';
import { getProductDescription } from '../../apis/metaData';
import { POI_BANK_STATUS } from '../../constants/response';
import { checkImgType } from '../../utilities/image_util';
import { getLanguageByRank } from '../../utilities/language';
/** 基本 meta tag 同 product page 商品頁
 * 但是 noindex 避免被 SEO
 */

const getSecretId = () => process.env.SECRET_ID_FOR_META_TAGS;

async function loadData(urlPath, language, query, params, headers) {
  const { userid, productid } = params;

  if (!userid) {
    return {
      metaData: null,
    };
  }

  try {
    const metaDataResult = await getProductDescription(
      userid,
      productid,
      getSecretId(),
    );

    if (metaDataResult.data.code !== POI_BANK_STATUS.SUCCESS) {
      return {
        notFound: true,
      };
    }

    const {
      nickname,
      description,
      cover,
      userid: realUserid,
      title,
      language: authorLanguage,
    } = metaDataResult.data.data.product;
    const metaLanguage = getLanguageByRank(
      query.hl,
      authorLanguage,
      headers['accept-language'],
    );
    const image = checkImgType({ data: cover, isSSR: true, widthLimit: 800 });
    const metaData = productMetaTagString({
      urlPath,
      title,
      image,
      description,
      language: metaLanguage,
      nickname,
      noindex: true,
    });

    if (userid === realUserid) {
      return {
        metaData,
      };
    }

    return {
      redirect: {
        status: 302,
        url: `${webServerHostUrl()}${realUserid}/products/${productid}`,
      },
    };
  } catch (error) {
    console.log('loadData -> error', error);
    return {
      metaData: null,
    };
  }
}

export default loadData;
